import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';

import { takeUntil } from 'rxjs';

import { AbstractComponent } from '../../shared/ui/abstract.component';

@Component({
  selector: 'placeme-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss'],
})
export class ClientComponent extends AbstractComponent implements OnInit {
  slidesPerView = 1.5;

  constructor(private breakpointObserver: BreakpointObserver) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small])
      .pipe(takeUntil(this.unsubscribeAll$))
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.slidesPerView = 1;
        } else {
          this.slidesPerView = 1.5;
        }
      });
  }
}
